import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import NoPage from "./pages/NoPage";

function App() {
	return (
		<>
			<Routes>
				<Route path="/" element={<Layout />}>
					<Route index element={<HomePage />} />
					<Route path="hakkimda" element={<AboutPage />} />
					<Route path="iletisim" element={<ContactPage />} />
					<Route path="*" element={<NoPage />} />
				</Route>
			</Routes>
		</>
	);
}

export default App;
